import React, { Component } from 'react';
import PhotoAlbums from './AlbumSelector';

export class Photos extends Component {
    static displayName = Photos.name;
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        return (
            <div>
                <h1>Photos</h1>
                
                <PhotoAlbums></PhotoAlbums>
            </div>
        );
    }
}
